import { IPaymentType } from "@swiggy-private/portal-dineout-ui";

// Razorpay SDK Types
export interface RazorpayOptions {
    keyId?: string;
    currency?: string;
    restaurantName?: string;
    description?: string;
    restaurantImage?: string;
    paymentOrderId?: string;
    customerName?: string;
    customerEmail?: string;
    contactNumber?: string;
    restaurantAddress?: string;
    swiggyOrderId?: string;
    paymentGateway?: string;
    transactionId?: string;
    amount?: number;
    paymentRetry?: boolean;
}

export interface RazorpayInstance {
    open: () => void;
    on: (event: string, handler: () => void) => void;
}

export interface RazorpayConstructor {
    new (options: RazorpayOptions): RazorpayInstance;
}

// useRazorpay Hook Types
export interface RazorpayHookOptions {
    razorpayKey?: string;
    currency?: string;
    restaurantName?: string;
    description?: string;
    restaurantImage?: string;
    paymentOrderId?: string;
    customerName?: string;
    customerEmail?: string;
    contactNumber?: string;
    restaurantAddress?: string;
    amount?: number;
}

export interface UseRazorpayReturn {
    initializeRazorpay: () => Promise<void>;
    onPayButtonClick: (paymentType: IPaymentType) => Promise<void>;
    isLoading: boolean;
    showHoldOrderModal: boolean;
}

export interface IFailureResponseCard {
    icon?: string;
    title?: string;
    message?: string;
    cta?: {
        text?: string;
        link?: string;
        type?: string;
    };
}

export type IOrderResponse = RazorpayOptions | IFailureResponseCard;

// Razorpay Extra Params Types
export interface RazorpayErrorMetadata {
    payment_id?: string;
}

export interface RazorpayError {
    metadata?: RazorpayErrorMetadata;
}

export interface RazorpayExtraParams {
    razorpay_payment_id?: string;
    error?: RazorpayError;
    [key: string]: string | RazorpayError | undefined;
}

// Payment Types
export type PaymentRedirectHandler = (paymentType: IPaymentType) => Promise<void>;

// Using string literal since IPaymentType is exported as a type from the dist package
export const PAYMENT_TYPE_RAZORPAY = "RAZORPAY" as IPaymentType;

export interface IOrderPendingParams {
    host: string;
    method: string;
    endpoint: string;
    headers?: {
        [key: string]: string;
    };
    body?: {
        [key: string]: string | number | object;
    };
}

export enum OrderFailInstance {
    PLACE = "place",
    PROCESS = "process",
    CONFIRM = "confirm",
}

export interface IOrderFailedEvent {
    orderId?: string;
    totalBill: string;
    failInstance: OrderFailInstance;
    error?: { statusCode?: number; statusMessage?: string } | Error;
}
